import { render, staticRenderFns } from "./SearchResultManifest.vue?vue&type=template&id=0795942e&scoped=true"
import script from "./SearchResultManifest.vue?vue&type=script&lang=js"
export * from "./SearchResultManifest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0795942e",
  null
  
)

export default component.exports